module.exports = __webpack_public_path__ + "img/gala.f16e0f70.png";